import React from "react"

import {ContentProvider} from "./src/context/ContentContext";

export const wrapRootElement = ({ element }) => (
    <ContentProvider>{element}</ContentProvider>
)
